<div class="payment-sip-emandate">
  <div *ngIf="!config?.showEmandateBankOnly" class="toggle-btn noselect mb-0">
    <button class="button-block" mat-stroked-button [ngClass]="config?.selectEmandateBank?'active':''" (click)="config.selectEmandateBank=true">Use Bank a/c no.</button>
    <button class="button-block" mat-stroked-button [ngClass]="!config?.selectEmandateBank?'active':''" (click)="config.selectEmandateBank=false">Use Card details</button>
  </div>

  <div [hidden]="!config?.selectEmandateBank && config?.selectedTab?.tabs?.includes('CARD')">
    <app-payment-sip-net-banking [config]="config" (dataEmit)="submitOrder($event)"></app-payment-sip-net-banking>
  </div>

  <div *ngIf="config?.selectedTab?.tabs?.includes('CARD') && !config?.selectEmandateBank">
    <app-payment-sip-card [config]="config" (dataEmit)="submitOrder($event)"></app-payment-sip-card>
  </div>

</div>